:host {
  --row-height: auto;
}

:host([lineSeparation]) {
  .formatted-text-container .content-formatted .line-number {
    border-right: 1px solid var(--chart-101-pressed-dividers);
    margin-right: var(--spacer);
  }

  .content-formatted {
    .line-container {
      align-items: center;
      padding: 0 var(--spacer);

      .line-number {
        padding: 0;
      }
    }
  }
}

.container {
  height: auto;
  width: auto;
}

.formatted-text-container {
  display: flex;
  white-space: break-spaces;
  word-break: break-word;
  width: 100%;
}

.content-formatted {
  width: 100%;

  .line-container {
    display: flex;
    align-items: baseline;
    padding: 4px var(--spacer);
    min-height: var(--row-height);

    &:hover {
      background: var(--chart-050-hover);
    }

    .line-number,
    .line-content {
      font-size: var(--body-size);
      font-family: var(--font-family);
      font-weight: 500;
      color: var(--body-text-arrows-400);
    }

    .line-number {
      max-width: 32px;
      min-width: 32px;
      user-select: none;
      pointer-events: none;
    }
  }
}

::selection {
  background-color: var(--blue-layout-402-primary-background);
  color: var(--white-layout-304-text);
}
